import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function BlogSection({ generalConfig }) {
    const authorName = generalConfig?.authorName || "Liliz Black";
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchPosts() {
            try {
                // Fetch all and handle filter/sort in memory to avoid index requirements
                const snap = await getDocs(collection(db, "blog"));
                const allPosts = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                
                const filtered = allPosts
                    .filter(p => p.published === true)
                    .sort((a, b) => {
                        const dateA = a.date ? new Date(a.date + "T00:00:00") : (a.createdAt?.toDate ? a.createdAt.toDate() : new Date(0));
                        const dateB = b.date ? new Date(b.date + "T00:00:00") : (b.createdAt?.toDate ? b.createdAt.toDate() : new Date(0));
                        return dateB - dateA;
                    })
                    .slice(0, 3); // Homepage limit

                setPosts(filtered);
            } catch (e) {
                console.error("Error fetching blog posts:", e);
            }
            setLoading(false);
        }
        fetchPosts();
    }, []);

    if (loading) return null;
    if (posts.length === 0) return null;

    return (
        <section className="blog-section" style={{ padding: "80px 20px", background: "#f9f9f9" }}>
            <div className="container">
                <div className="section-header" style={{ marginBottom: 40, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                    <div>
                        <h2 className="section-title" style={{ margin: 0, textAlign: "left" }}>The Latest News</h2>
                        <p style={{ color: "#666", marginTop: 8 }}>Stay updated with {authorName}'s worlds.</p>
                    </div>
                    <Link to="/news" className="view-all-link" style={{ color: "var(--accent)", fontWeight: 600, display: "flex", alignItems: "center", gap: 6, textDecoration: "none" }}>
                        View all posts <FiArrowRight />
                    </Link>
                </div>

                <div className="blog-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 30 }}>
                    {posts.map(post => (
                        <div key={post.id} className="blog-card" style={{ background: "#fff", borderRadius: 12, overflow: "hidden", boxShadow: "0 4px 15px rgba(0,0,0,0.05)", transition: "transform 0.3s" }}>
                            <div className="blog-card-image" style={{ height: 200, overflow: "hidden" }}>
                                <img src={post.imageUrl || "https://images.unsplash.com/photo-1512820790803-83ca734da794?q=80&w=1000"} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            </div>
                            <div className="blog-card-content" style={{ padding: 24 }}>
                                <span style={{ fontSize: 12, color: "var(--accent)", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1 }}>
                                    {post.date 
                                        ? new Date(post.date + "T00:00:00").toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) 
                                        : (post.createdAt?.toDate ? post.createdAt.toDate().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : "Recent")
                                    }
                                </span>
                                <h3 style={{ margin: "12px 0", fontSize: "1.25rem", color: "var(--primary)" }}>{post.title}</h3>
                                <p style={{ color: "#666", fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>{post.excerpt}</p>
                                <Link to={`/news/${post.id}`} style={{ color: "var(--primary)", fontWeight: 700, textDecoration: "none", fontSize: 14, borderBottom: "2px solid var(--accent)" }}>Read More</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
